









































import { defineComponent, toRefs, computed, ref, nextTick, watch, onMounted } from '@vue/composition-api';
import { ChevronLeftIcon, InfoCircleFilledIcon } from 'tdesign-icons-vue';
import loginWithWeComHandler from '@/renderer/components/login/compositions/loginWithWeComHandler';
import { CONSTANT_URL } from '@/renderer/scripts/http';

import SelectInput from './SelectInput.vue';

export default defineComponent({
  components: {
    ChevronLeftIcon,
    InfoCircleFilledIcon,
    SelectInput,
  },
  props: {
    show: {
      type: Boolean,
    },
    config: {
      type: Object,
      default: {
        appid: '',
        agentid: '',
      },
    },
  },
  setup(props, context) {
    const vm = context.root;
    const { config } = toRefs(props);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const {
      isCustomizedDomain,
      iframeUrl,
      getWeComUrlFailed,
      customId,
      customIdList,
      methods: loginMethods,
    } = loginWithWeComHandler();
    const methods = {
      cancel() {
        innerShow.value = false;
        context.emit('cancel');
      },
    };

    // 企业id不支持空格
    watch(customId, val => {
      customId.value = `${val}`.replace(/\s/g, '');
    });
    onMounted(() => {
      // 自定义域名直接展示二维码
      if (isCustomizedDomain) {
        customId.value = (vm.$route.query?.domain_prefix as string) || '';
        const domain = [customId.value, CONSTANT_URL.currentDomain].filter(v => v).join('.');
        const redirectUrl = loginMethods.getRedirectUrl(domain);
        iframeUrl.value = loginMethods.getIframeUrl(config.value.appid, config.value.agentid, redirectUrl);
        nextTick(() => {
          loginMethods.renderWeComCode(config.value.appid, config.value.agentid, redirectUrl);
        });
        return;
      }
      // 只有一个企业时自动登录
      if (vm.$store.getters.corpList.length === 1) {
        loginMethods.getWeComIframe();
      }
    });
    return {
      innerShow,
      customId,
      customIdList,
      getWeComUrlFailed,
      iframeUrl,
      ...methods,
      ...loginMethods,
    };
  },
});
